<template>
  <div
    class="
      relative
      flex
      items-top
      justify-center
      min-h-screen
      bg-gray-100
      sm:items-center
      sm:pt-0
    "
  >
    <div class="max-w-6xl mx-auto sm:px-6 lg:px-8">
      <div class="flex justify-center pt-8 sm:justify-start">
        <img
          src="/img/logo-thnic.svg"
          class="h-20 w-auto text-gray-700 sm:h-20"
        />
        <div class="ml-5">
          <div class="text-sm sm:text-2xl">
            โครงการส่งเสริมธุรกิจไทยใช้พาณิชย์อิเล็กทรอนิกส์
          </div>
          <div
            v-if="registration.type == 'C'"
            class="text-2xl sm:text-4xl text-blue-900 mt-1"
          >
            แบบลงทะเบียนสำหรับนิติบุคคล
          </div>
          <div v-else class="text-2xl sm:text-3xl text-blue-900 mt-2">
            แบบลงทะเบียนสำหรับบุคคลธรรมดาที่มีเครื่องหมาย DBD Registered
          </div>
        </div>
      </div>

      <div class="mt-6 bg-white overflow-hidden shadow sm:rounded-lg">
        <div class="bg-blue-900 px-6 py-8">
          <div class="text-white text-center font-semibold">
            <div class="text-yellow-500 text-2xl">ได้รับข้อมูลการลงทะเบียนของท่านแล้ว</div>
            <div class="text-white text-xl mt-4">เมื่อเราตรวจสอบข้อมูลแล้ว จะแจ้งผลการลงทะเบียนทางอีเมลภายใน 3 วัน</div>
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 border-t border-gray-200">
          <div class="p-6">
            <div class="flex items-center">
              <svg
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                viewBox="0 0 24 24"
                class="w-8 h-8 text-gray-500"
              >
                <path
                  d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                ></path>
              </svg>
              <div class="ml-4 text-lg leading-7 font-semibold">
                <span class="text-blue-900">ข้อกำหนดและเงื่อนไข</span>
              </div>
            </div>

            <div class="ml-12">
              <div class="mt-2 text-gray-600 text-sm">
                <ul class="mt-2 ml-3 list-outside list-disc">
                  <li>สามารถจดทะเบียนเว็บไซต์/โดเมนได้เพียง 1 ชื่อเท่านั้น</li>
                  <li>
                    สำหรับเว็บไซต์ฟรี 1 หน้า ทางโครงการฯ
                    มีระบบจัดการที่สามารถปรับแต่งหน้าตาของเว็บไซต์
                    โดยท่านจะได้รับบัญชีเข้าสู่ระบบฯ
                    หลังจากที่ทางมูลนิธิฯอนุมัติการจดทะเบียนเว็บไซต์/โดเมนของท่านแล้ว
                  </li>
                  <li>
                    หากท่านไม่ต้องการใช้เว็บไซต์ที่ทางโครงการจัดเตรียมให้ท่านสามารถทำการตั้งค่าเว็บไซต์/โดเมนของท่านไปยัง
                    web hosting ที่ท่านได้จัดเตรียมไว้ได้
                  </li>
                  <li v-if="registration.type == 'C'">
                    สำหรับเว็บไซต์/โดเมน .co.th ชื่อเว็บไซต์/โดเมนจำเป็นต้องสอดคล้อง,
                    เป็นส่วนใดส่วนหนึ่ง หรือย่อมาจากชื่อองค์กรเท่านั้น
                  </li>
                  <li>
                    มูลนิธิฯขอสงวนสิทธิ์การปฏิเสธการจดทะเบียนชื่อเว็บไซต์/โดเมนที่ไม่เป็นไปตามเงื่อนไขข้างต้น
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="p-6 border-t border-gray-200 md:border-t-0 md:border-l">
            <div class="flex items-center">
              <svg
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                viewBox="0 0 24 24"
                class="w-8 h-8 text-gray-500"
              >
                <path
                  d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                ></path>
              </svg>
              <div class="ml-4 text-lg leading-7 font-semibold">
                <span class="text-blue-900"
                  >สิ่งที่จะได้รับหลังจากลงทะเบียน</span
                >
              </div>
            </div>

            <div class="ml-12">
              <div class="mt-2 text-gray-600 text-sm">
                หลังจากที่มูลนิธิฯ
                ตรวจสอบข้อมูลนิติบุคคลกับกรมพัฒนาธุรกิจการค้าเรียบร้อย
                และส่งจดทะเบียนชื่อเว็บไซต์/โดเมนสำเร็จ ท่านจะได้รับ
                <ul class="mt-2 ml-3 list-outside list-disc">
                  <li>อีเมลสำหรับจัดการตั้งค่าเว็บไซต์/โดเมน</li>
                  <li>อีเมลสำหรับจัดการตั้งค่าเว็บไซต์</li>
                  <li>
                    เครื่องหมาย DBD Registered (หากท่านแจ้งความประสงค์ไว้)
                    หลังจากที่กรมพัฒนาธุรกิจการค้าได้พิจารณาใบสมัครของท่านแล้ว
                    ทางกรมฯ จะแจ้ง code
                    สำหรับติดตั้งเครื่องหมายบนหน้าเว็บไซต์ให้กับท่านทางอีเมลที่ลงทะเบียนไว้
                  </li>
                  <li>
                    เป็นสมาชิกของสมาคมต่าง ๆ ที่ระบุไว้ในโครงการ เป็นเวลา 1 ปี
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="my-4 grid grid-cols-1 md:grid-cols-2">
        <div class="text-sm text-center md:text-left text-gray-500">
          <a href="https://thaionline.in.th" class="ml-1 underline">
            หน้าหลักของโครงการ
          </a>
        </div>

        <div
          class="
            mt-3
            md:mt-0
            text-sm text-center
            md:text-right
            text-gray-500
            sm:ml-0
          "
        >
          โครงการส่งเสริมธุรกิจไทยใช้พาณิชย์อิเล็กทรอนิกส์
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["registration"],
};
</script>
